'use strict';

var SiteConstants = require('constants/SiteConstants');
var updateMiniCart = true;

function setMiniCartBodyMaxHeight(minicart) {
    var $minicart = $(minicart);
    var $minicartScrollable = $minicart.find('.product-summary');
    var minicartHeight = $minicart.outerHeight();
    var minicartScrollableHeight = $minicartScrollable.outerHeight();
    var minicartNonScrollableHeight = minicartHeight - minicartScrollableHeight;
    var minicartOffset = $minicart.offset().top - $(window).scrollTop();
    var subtractHeight = minicartOffset + minicartNonScrollableHeight + SiteConstants.Spacer;

    if (window.isMobile()) {
        subtractHeight = subtractHeight + 100; // leave extra space for bottom mobile browser chrome
    }

    $minicartScrollable.css('max-height', 'calc(100vh - ' + subtractHeight + 'px)');
}

module.exports = function () {
    $('.minicart').on('count:update', (event, count) => {
        if (count && $.isNumeric(count.quantityTotal)) {
            if (count.quantityTotal <= 99) {
                if (count.quantityTotal == 0) {
                    $('.minicart .minicart-quantity').addClass('visually-hidden').text(count.quantityTotal);
                }
                else {
                    $('.minicart .minicart-quantity').removeClass('visually-hidden').text(count.quantityTotal);
                }
            }
            else {
                $('.minicart .minicart-quantity').removeClass('visually-hidden').text('99+');
            }
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('.minicart').on('mouseenter focusin touchstart', event => {
        var $target = $(event.target);
        var isMobileCartTap = event.type === 'touchstart' && $target.closest('.minicart-link').length > 0;

        if ($target.closest('.checkout-header').length > 0 || $(event.currentTarget).data('hide-minicart')) {
            return;
        }

        if (isMobileCartTap) {
            event.preventDefault(); // prevent from redirecting to cart page
        }

        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart && !$('.minicart .popover').is(':empty')) {
                $('body').addClass('minicart-active');
                $('.minicart .popover').addClass('show');
                return;
            }
            $('body').addClass('minicart-active');
            $('.minicart .popover').addClass('show');
            $('.minicart .popover').spinner().start();
            $.get(url, data => {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                updateMiniCart = false;
                $.spinner().stop();
                $('body').trigger('minicart:loaded', $('.minicart .popover'));
                $('body').addClass('minicart-active');
            });
        } else if (isMobileCartTap && $('.minicart .popover.show').length > 0) {
            // toggle minicart on icon tap in mobile
            $('.minicart .popover').removeClass('show');
            $('body').removeClass('minicart-active');
        }
    });

    $('body').on('touchstart click', event => {
        if ($('.minicart').has(event.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
            $('body').removeClass('minicart-active');
        }
    });

    $('.minicart').on('mouseleave focusout', event => {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
            || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
            || ($(event.target).is('.tooltip-icon') || $(event.relatedTarget).is('.tooltip'))
            || $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
        $('.minicart .popover').removeClass('show');
        $('body').trigger('minicart:mouseleave_focusout');
        $('body').removeClass('minicart-active');
    });

    $('body').on('change', '.minicart .quantity', event => {
        if ($(event.target).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    $('body').on('product:afterAddToCart cart:update', () => {
        updateMiniCart = true;
    });

    $('body').on('minicart:loaded', (event, minicart) => {
        setMiniCartBodyMaxHeight(minicart);
        $(minicart).trigger('tooltip:init');
    });
};
